import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Tooltip } from '@dixa/lib-shared-habla';
import _isEqual from 'lodash/isEqual';
import * as React from 'react';
import { Field } from 'redux-form';
import AutocompleteUserAsync from '../../customDropdown/AutocompleteUserAsync';
class ListUserEmailOptions extends React.Component {
    constructor(props) {
        super(props);
        this.onFocusFunction = () => {
            this.setState({ active: true });
        };
        this.onBlurFunction = (e) => {
            this.setState({ active: false });
        };
        this.state = {
            active: false,
        };
        this.labelRef = React.createRef();
    }
    componentDidMount() {
        if (this.props.focus && this.labelRef.current) {
            this.labelRef.current.click();
        }
    }
    shouldComponentUpdate(nProps, nState) {
        return !_isEqual(this.props, nProps) || !_isEqual(this.state, nState);
    }
    render() {
        const { fields, fieldLabel, meta: { touched, submitFailed, error, valid, form, pristine }, availableOptions, singleChoice, required: requiredField, touch, className, placeholder, hideField, } = this.props;
        const hasError = (touched || submitFailed) && error ? 'has-error' : '';
        const hasSuccess = valid && pristine === false ? 'has-success' : '';
        let isSearchShown = true;
        const selectedOptions = [];
        let noneFoundMessage = 'None found';
        let formGroupClasses = className && typeof className === 'string' ? className : '';
        fields.map((field, index) => {
            const f = fields.get(index);
            selectedOptions.push(f.user);
        });
        let filteredFields = availableOptions.map((x) => Object.assign(x, selectedOptions.find((y) => y.id === x.id)));
        if (selectedOptions.length > 0 && singleChoice === true) {
            filteredFields = [];
            isSearchShown = false;
            noneFoundMessage =
                'Only a single choice can be selected. Remove the selected choice if you want another.';
        }
        if (availableOptions === null) {
            filteredFields = [];
        }
        if (this.state.active === true) {
            formGroupClasses += ' focused';
        }
        return (_jsxs("div", Object.assign({ className: `form-group list-user-options-fields user-options-styled ${formGroupClasses} ${hasSuccess} ${hasError}` }, { children: [_jsxs("label", Object.assign({ ref: this.labelRef, className: `control-label ${hasSuccess} ${hasError}`, htmlFor: "autocomplete-user" }, { children: [fieldLabel ? fieldLabel : 'Actions', requiredField === true && _jsx("span", { children: " * " }), (touched || submitFailed) && error && (_jsx("span", Object.assign({ className: "validation-text" }, { children: error })))] })), hideField && (_jsx("button", Object.assign({ type: "button", className: "btn remove-btn hide-cc-bcc", onClick: () => hideField(fieldLabel) }, { children: _jsx(DixaIcon, { icon: "close" }) }))), fields.map((contactField, index) => {
                    const field = fields.get(index);
                    let hasName = false;
                    let nameInput = null;
                    if (field.user.id &&
                        field.user.display_name &&
                        typeof field.user.display_name === 'string') {
                        hasName = true;
                    }
                    else {
                        nameInput = (_jsx(Field, { type: "text", className: "add-name", name: `${contactField}.user.display_name`, component: "input", placeholder: "Add a name (optional)..." }));
                    }
                    const displayname = hasName == true
                        ? `${field.user.display_name} <${field.user.email}>`
                        : field.user.email;
                    return (_jsx(Tooltip, Object.assign({ content: displayname, dark: true }, { children: _jsx("div", Object.assign({ className: "selected-email field-action" }, { children: _jsxs("div", Object.assign({ className: "selected-email-label" }, { children: [_jsx("span", Object.assign({ className: "label-email" }, { children: displayname })), nameInput, _jsx("button", Object.assign({ type: "button", className: "btn remove-btn", onClick: () => {
                                            fields.remove(index);
                                        } }, { children: _jsx(DixaIcon, { icon: "close" }) }))] })) })) }), index));
                }), _jsx(AutocompleteUserAsync, { touch: touch, stopFormSubmit: this.props.stopFormSubmit, isShown: isSearchShown, formName: form, noneFoundMessage: noneFoundMessage, getfunction: this.props.getfunction, placeholder: placeholder, elements: filteredFields, ElementItem: this.props.elementItem, onFocusFunction: this.onFocusFunction, onBlurFunction: this.onBlurFunction, status: this.props.status, add: fields.push, error: fields.error, fields: fields, numberOfResults: availableOptions.length }), this.props.children] })));
    }
}
export default ListUserEmailOptions;
